import React from "react";
import ReactDOM from "react-dom/client";
import { observerBatching, Provider } from "mobx-react";
import "core-js/stable";
import "cross-fetch/polyfill";
import { configure } from "mobx";
import { MessageProvider } from "react-message-context";
import { HashRouter } from "react-router-dom";
import messageData from "./messages/msgData";
import App from "./App";
import RestStore from "./stores/RestStore";
import FeedbackStore from "./stores/FeedbackStore";
import AnalyticsStore from "./stores/AnalyticsStore";
import SessionStore from "./stores/SessionStore";
import reportWebVitals from "./reportWebVitals";
import { makeServer } from "./server";
import { LocaleProvider } from "@op/opds.opux";

observerBatching(ReactDOM.unstable_batchedUpdates);
configure({ isolateGlobalState: true });

if (process.env.NODE_ENV === "development") {
  makeServer({ environment: "development" });
}

const params = window.CFF_PARAMS;
const language = (document.documentElement.getAttribute("lang") || "fi")
  .substring(0, 2)
  .toLowerCase();
const stores = { RestStore, FeedbackStore, AnalyticsStore, SessionStore };
const root = ReactDOM.createRoot(
  document.getElementById("customerfeedbackopfi-main")
);

root.render(
  <React.StrictMode>
    <MessageProvider messages={messageData[language]} locale={language}>
      <LocaleProvider locale={language}>
        <Provider {...stores}>
          <HashRouter>
            <App {...params} />
          </HashRouter>
        </Provider>
      </LocaleProvider>
    </MessageProvider>
  </React.StrictMode>
);

if (params.dev) {
  // For easier debugging
  window.__APP_STATE__ = stores;

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals(console.log);
}
